(() => {
  const ROOT_SELECTOR = 'cardology-header.cdo-header';

  function openSharedSearch(button) {
    const root = button.closest(ROOT_SELECTOR);
    if (!root) return;

    const drawer = root.querySelector('[data-cdo-mobile-drawer]');
    const overlay = root.querySelector('[data-cdo-search-overlay]');
    if (!overlay) return;

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    }

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      document.body.classList.add('cdo-header-lock');

      window.setTimeout(() => {
        const input = overlay.querySelector('[data-cdo-search-input-mobile]');
        if (input) input.focus({ preventScroll: true });
      }, 50);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cdo-mobile-search-open]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openSharedSearch(button);
  }, true);
})();
